export const getFacilityPreviewIconPath = (facility: string): string => {
  return `/svg/icon-${facility}.svg`;
};
